module.exports = require('./lib/linkify-html').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/html.js
// module id = 292
// module chunks = 1